import { sizeTab, texto, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import SolicitudIngresoBodegaAprobadasPagina from "./solicitudes-ingreso-bodega-aprobadas/solicitudesIngresoBodegaAprobadasPage";
import SolicitudIngresoBodegaEnEsperaPagina from "./solicitudes-ingreso-bodega-en-espera/solicitudesIngresoBodegaEnEsperaPage";
import SolicitudIngresoBodegaRechazadosPagina from "./solicitudes-ingreso-bodega-rechazados/solicitudesIngresoBodegaRechazadosPage";

export default function SolicitudIngresoBodegaPagina() {

  const [valueTab, setValueTab] = useState(0);

  return (

    <SingleTableBoxScene title={"Recepcion Solicitudes Ingreso"} >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          <Tab label={texto.solicitud_espera} {...a11yProps(0)} />
          <Tab label={texto.solicitudes_aprobadas} {...a11yProps(1)} />
          <Tab label={texto.solicitud_rechazada} {...a11yProps(2)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <SolicitudIngresoBodegaEnEsperaPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <SolicitudIngresoBodegaAprobadasPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <SolicitudIngresoBodegaRechazadosPagina  />
      </CustomTabPanel>

    </SingleTableBoxScene>
  );


}


